import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { AmountPage, CarrierPage, EMVDataPage, IndicatorPage, TransactionPage, TVRCVRPage } from './archivedTables/validTransactionInquiryHistory';

const ConsultationAuthorizationsDetailsLayout = () => {
  
  const orientation = CC.useBreakpointValue(
    { 
      base: 'vertical', 
      "2xl": 'vertical', 
    }, 
    { 
      fallback: 'md', 
    }, 
  ) as "horizontal" | "vertical";

  const tabHeaders = React.useMemo(
    () => [
      'Données principales',
      'Titulaire de carte',
      'Marchand',
      'Montants',
      'Code réponse',
      'Mode Entrée POS',
      'Données originales',
      'Divers',
      'Donnée\u{202F}\u{202F}EMV', // \u{202F} = code js caractère insécable
      'TVR/CVR',
    ],
    []
  );

  const tabLinks = React.useMemo(
    () => [
      'main-data',
      'cardholder',
      'merchant',
      'amount',
      'response-code',
      'pos-entry-mode-code',
      'original-data',
      'miscellaneous',
      'emv-data',
      'tvr-cvr',
    ],
    []
  );

  const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');

  return (
    <>
      
      {/* Back to previous page Section */}
      <CC.HStack>
        <Link
          to={
            URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU
              .CONSULTATION_OF_AUTHORIZATIONS
          }
        >
          <CC.Box
            borderRadius={'50%'}
            p={'0.5rem'}
            _hover={{ backgroundColor: `${bg}` }}
          >
            <FaArrowLeft size={'1.5rem'} />
          </CC.Box>
        </Link>

        <CC.Hide below="md">
          <CC.Heading size="lg">Autorisations</CC.Heading>
        </CC.Hide>

        <CC.Show below="md">
          <CC.Heading size="lg">Retour</CC.Heading>
        </CC.Show>
      </CC.HStack>

      <CC.Divider my={'2rem'} />

      <CC.Tabs orientation={orientation} isLazy defaultIndex={0} px={{ base: "1rem", xl: '2rem'}} pr={"0"} mt={"2rem"}>
        <CC.Box as={"div"} style={{ overflow: 'auto' }} minW={'200px'} mt={'1.2rem'}>
          <CC.TabList  alignItems={"flex-start"} pr={"0"}>
            {tabHeaders.map((tab, index) => (
              <NavLink to={tabLinks[index]} key={index}>
                <CC.Tab _hover={{ textColor: `${CC.useColorModeValue('black.50', 'red.50')}`, backgroundColor: `${CC.useColorModeValue('blue.50', 'blue.600')}`, borderRadius: "5px" }}>
                  {tab}
                </CC.Tab>
              </NavLink>
            ))}
          </CC.TabList>
        </CC.Box>

        <CC.TabPanels>
          {tabHeaders.map((_, index) => (
            <CC.TabPanel key={index}>
              <Outlet />
            </CC.TabPanel>
          ))}
        </CC.TabPanels>
      </CC.Tabs>
    </>
  );
};

export default ConsultationAuthorizationsDetailsLayout;
